import { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import axiosConn from '../../axiosConn';
import { AuthContext } from '../../context/AuthContext';
import getActivePlayers from '../../utils/getActivePlayers';

const EXCLUDED_PLAYER_IDS = new Set([
  'secondDayOut',
  'infoJG',
  'newrockstar',
  'stester',
  'rockstarJG',
  'thirdDayDayOut',
  'firstDayOut',
  'jgktokenKing',
  'btester',
  'jgtesterone',
  'winninghands',
  'InterfaceOne',
  'coachCarlosThree',
  'FredSanFord',
  'supportNET',
  'jgdotnet',
]);

const formatJgk = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return '0';
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(
    numeric,
  );
};

export default function JGKLeaderMini() {
  const { player } = useContext(AuthContext);
  const token = player?.token;

  const getAllPlayersSortJGK = async () => {
    const res = await axiosConn.get(`players/?sort=-jgkTokens`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const players = res.data.data.data || [];
    const activePlayers = getActivePlayers(players);
    return activePlayers;
  };

  const { data = [], isLoading } = useQuery(
    'allPlayersSortJGK',
    getAllPlayersSortJGK,
    { enabled: Boolean(token) },
  );

  const topPlayers = useMemo(() => {
    return (data || [])
      .filter((p) => !EXCLUDED_PLAYER_IDS.has(p.playerId))
      .slice(0, 3);
  }, [data]);

  return (
    <div className="feedHighlightCard feedHighlightCard--jgk">
      <div className="feedHighlightCardHeader">
        <span className="feedHighlightTitle">JGK Top 10</span>
        <Link className="feedHighlightCta" to="/jgktoken">
          See Top 10
        </Link>
      </div>
      <div className="jgkMiniList">
        {isLoading && (
          <div className="jgkMiniPlaceholder">Loading leaders...</div>
        )}
        {!isLoading &&
          topPlayers.map((playerItem, index) => (
            <div key={playerItem._id} className="jgkMiniRow">
              <span className="jgkMiniRank">{index + 1}</span>
              <Link to={`/profile/${playerItem.playerId}`} className="jgkMiniAvatar">
                <img
                  src={
                    playerItem.profilePhoto ||
                    'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                  }
                  alt=""
                  loading="lazy"
                />
              </Link>
              <Link to={`/profile/${playerItem.playerId}`} className="jgkMiniId">
                {playerItem.playerId}
              </Link>
              <span className="jgkMiniScore">
                {formatJgk(playerItem.jgkTokens)}
              </span>
            </div>
          ))}
        {!isLoading && topPlayers.length === 0 && (
          <div className="jgkMiniPlaceholder">No leaders yet.</div>
        )}
      </div>
    </div>
  );
}
